import React, { useContext, useEffect, useRef, useState } from "react";
import { Checkbox, Switch } from "@mui/material";
import { CustomizableProjectPagesService } from "../../../../../../api";
import { useApi } from "../../../../../hooks";
import { FORM_SUBTYPES } from "../../../form-enum";
import { SectionsContext } from "../../../CustomizableForm";
import { Selector } from "../../../../text-fields";
import { translate } from "../../../../../providers";
import styles from "./CustomFormBoolean.module.css";

export default function CustomFormBoolean({
	block,
	editMode,
	customPageId,
	hasEditorRights = false,
	projectId,
	onGlobalUpdate,
	sectionId,
}) {
	const [localValue, setLocalValue] = useState("");
	const { updateLocalSection } = useContext(SectionsContext);
	const customTextRef = useRef(null);
	const { currentValue = false, subtype } = block.options;
	const { call: updateCustomPage } = useApi(CustomizableProjectPagesService.updateCustomPage);
	useEffect(() => {
		if (currentValue) {
			setLocalValue(currentValue);
		}
	}, [currentValue]);
	const handleSubmit = () => {
		if (!editMode) {
			const newValue = localValue === "TRUE" ? "FALSE" : "TRUE";
			if (onGlobalUpdate && typeof onGlobalUpdate === "function") {
				onGlobalUpdate({ uuid: block.id, value: newValue });
				updateLocalSection(sectionId, block.id, { currentValue: newValue });
				setLocalValue(newValue);
			} else {
				updateCustomPage({ customPageId, projectId }, { uuid: block.id, value: newValue })
					.then(() => {
						setLocalValue(newValue);
						updateLocalSection(sectionId, block.id, { currentValue: newValue });
					})
					.catch(console.error);
			}
		}
	};
	const handleChangeValue = () => {
		handleSubmit();
	};
	return (
		<div ref={customTextRef}>
			{(subtype === FORM_SUBTYPES.TOGGLE && (
				<Switch
					checked={localValue === "TRUE"}
					color="primary"
					disabled={!hasEditorRights || block?.readOnly}
					onClick={handleSubmit}
				/>
			)) ||
				(subtype === FORM_SUBTYPES.LIST && (
					<Selector
						fullWidth
						className={styles.booleanInput}
						itemRenderer={(label) => translate(`common:boolean.${label.toLowerCase()}`)}
						items={["TRUE", "FALSE"]}
						size="small"
						value={localValue}
						valueRenderer={(value) => translate(`common:boolean.${value.toLowerCase()}`)}
						onChange={handleChangeValue}
					/>
				)) || (
					<Checkbox
						checked={localValue === "TRUE"}
						color="primary"
						disabled={!hasEditorRights || block?.readOnly}
						onClick={handleSubmit}
					/>
				)}
		</div>
	);
}
